(function () {
  'use strict';
  var $ = function (s, k) { return (k || document).querySelector(s); };
  var $$ = function (s, k) { return Array.prototype.slice.call((k || document).querySelectorAll(s)); };

  /* ---------- mobil menu ---------- */
  var mobil = $('[data-mobil]');
  if (mobil) {
    var ac = function () { mobil.hidden = false; requestAnimationFrame(function () { mobil.classList.add('acik'); }); document.body.style.overflow = 'hidden'; };
    var kapat = function () { mobil.classList.remove('acik'); document.body.style.overflow = ''; setTimeout(function () { mobil.hidden = true; }, 300); };
    $$('[data-mobil-ac]').forEach(function (b) { b.addEventListener('click', ac); });
    $$('[data-mobil-kapat]').forEach(function (b) { b.addEventListener('click', kapat); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mobil.classList.contains('acik')) kapat(); });
  }

  /* ---------- hero slayt ----------
     Gorunurluk yalnizca .aktif sinifiyla yonetilir (CSS'te grid ustuste yigma).
     hidden ozniteligine bagimli degil. */
  $$('[data-hero]').forEach(function (hero) {
    var slaytlar = $$('[data-slayt]', hero);
    if (slaytlar.length < 2) return;

    var noktalar = $$('[data-git]', hero);
    var i = 0, zaman = null;
    var sure = parseInt(hero.dataset.sure, 10) || 6000;
    var otomatik = hero.dataset.otomatik !== 'false';
    var azHareket = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goster(n) {
      i = (n % slaytlar.length + slaytlar.length) % slaytlar.length;
      slaytlar.forEach(function (s, x) {
        var aktif = x === i;
        s.classList.toggle('aktif', aktif);
        s.setAttribute('aria-hidden', String(!aktif));
        $$('a, button', s).forEach(function (o) {
          if (aktif) { o.removeAttribute('tabindex'); } else { o.setAttribute('tabindex', '-1'); }
        });
      });
      noktalar.forEach(function (d, x) {
        d.classList.toggle('aktif', x === i);
        d.setAttribute('aria-selected', String(x === i));
      });
    }

    function durdur() { if (zaman) { clearInterval(zaman); zaman = null; } }
    function basla() {
      durdur();
      if (!otomatik || azHareket) return;
      zaman = setInterval(function () { goster(i + 1); }, sure);
    }

    noktalar.forEach(function (d) {
      d.addEventListener('click', function () { goster(+d.dataset.git); basla(); });
    });
    $$('[data-hero-ok]', hero).forEach(function (b) {
      b.addEventListener('click', function () { goster(i + (+b.dataset.heroOk)); basla(); });
    });

    hero.addEventListener('mouseenter', durdur);
    hero.addEventListener('mouseleave', basla);
    hero.addEventListener('focusin', durdur);
    hero.addEventListener('focusout', basla);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { durdur(); } else { basla(); }
    });

    /* dokunmatik kaydirma */
    var bx = 0, by = 0;
    hero.addEventListener('touchstart', function (e) {
      bx = e.changedTouches[0].clientX; by = e.changedTouches[0].clientY; durdur();
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - bx, dy = e.changedTouches[0].clientY - by;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { goster(i + (dx < 0 ? 1 : -1)); }
      basla();
    }, { passive: true });

    goster(0);
    basla();
  });

  /* ---------- yatay kaydirak ---------- */
  $$('.kaydirak').forEach(function (k) {
    var ray = $('[data-ray]', k);
    $$('[data-kaydir]', k).forEach(function (b) {
      b.addEventListener('click', function () {
        ray.scrollBy({ left: (+b.dataset.kaydir) * ray.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  });

  /* ---------- akordeon ---------- */
  $$('[data-akordeon]').forEach(function (b) {
    b.addEventListener('click', function () {
      var acik = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', String(!acik));
      b.nextElementSibling.classList.toggle('acik', !acik);
    });
  });

  /* ---------- urun: adet ---------- */
  $$('[data-adet]').forEach(function (b) {
    b.addEventListener('click', function () {
      var inp = $('input[name=quantity]', b.closest('.ur__adet'));
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+b.dataset.adet));
    });
  });

  /* ---------- urun: galeri ---------- */
  var anaImg = $('[data-ana-img]');
  if (anaImg) {
    $$('[data-kucuk]').forEach(function (b) {
      b.addEventListener('click', function () {
        anaImg.src = b.dataset.kucuk;
        $$('[data-kucuk]').forEach(function (x) { x.classList.remove('aktif'); });
        b.classList.add('aktif');
      });
    });
  }

  /* ---------- urun: varyant secimi ---------- */
  var secici = $('[data-varyant-secici]');
  if (secici) {
    var secimler = $$('[data-secenek-index]').map(function (g) {
      var s = $('.secili', g);
      return s ? s.dataset.deger : ($('.ur__deger', g) || {}).dataset.deger;
    });

    var guncelle = function () {
      var basli = secimler.join(' / ');
      var opt = null;
      $$('option', secici).forEach(function (o) { if (o.textContent.trim() === basli) opt = o; });
      if (!opt) return;
      secici.value = opt.value;

      var fiyat = $('[data-fiyat]'), stokYazi = $('[data-stok-yazi]'), btn = $('[data-sepete-ekle]');
      if (fiyat) {
        fiyat.innerHTML = '<span>' + opt.dataset.fiyat + '</span>' +
          (opt.dataset.eski ? '<del>' + opt.dataset.eski + '</del>' : '');
      }
      var uygun = opt.dataset.uygun === 'true', stok = parseInt(opt.dataset.stok, 10);
      if (stokYazi) {
        stokYazi.className = 'ur__stok' + (!uygun ? ' ur__stok--yok' : (stok > 0 && stok < 5 ? ' ur__stok--az' : ''));
        stokYazi.textContent = !uygun ? 'Tükendi' : (stok > 0 && stok < 5 ? 'Son ' + stok + ' adet' : 'Stokta var');
      }
      if (btn) { btn.disabled = !uygun; btn.textContent = uygun ? 'Sepete Ekle' : 'Tükendi'; }

      var url = new URL(window.location);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url);
    };

    $$('[data-secenek-index]').forEach(function (grup) {
      var idx = +grup.dataset.secenekIndex;
      $$('.ur__deger', grup).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.ur__deger', grup).forEach(function (x) { x.classList.remove('secili'); });
          b.classList.add('secili');
          secimler[idx] = b.dataset.deger;
          guncelle();
        });
      });
    });
  }

  /* ---------- sepet: satir adedi ---------- */
  $$('[data-satir-adet]').forEach(function (b) {
    b.addEventListener('click', function () {
      var inp = $('input[data-satir="' + b.dataset.satirAdet + '"]');
      inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + (+b.dataset.yon));
      inp.form.querySelector('[name=update]').click();
    });
  });

  /* ---------- sepete ekle (sayfa yenilemeden sayaci guncelle) ---------- */
  var form = $('#urun-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var btn = $('[data-sepete-ekle]', form);
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var eski = btn.textContent;
      btn.disabled = true; btn.textContent = 'Ekleniyor...';

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (sepet) {
          var s = $('[data-sepet-sayaci]');
          if (s) s.textContent = sepet.item_count;
          btn.textContent = 'Sepete eklendi ✓';
          setTimeout(function () { btn.textContent = eski; btn.disabled = false; }, 1800);
        })
        .catch(function () { form.submit(); });
    });
  }
})();
